module.exports = {"data":{"site":{"siteMetadata":{"siteTitle":"Healthful&Inspired: The best site to find health and weight loss reads","siteName":"Healthful&Inspired","siteUrl":"https://healthfulinspired.com","siteDescription":"Actively sharing the most useful health content for health, wellness, fitness, weight loss, fat burn & diets for people who want to become healthier. Subscribe!"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 601
// module chunks = 60335399758886 114276838955818